<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    class="make-a-copy"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import genderColors from '@/mixins/gender-model';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'GenderPieChart',
  components: {
    PieChart,
  },
  mixins: [
    genderColors,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      classifiedPercentage: 0,
    };
  },
  computed: {
    series() {
      if (this.rawSeries.length) {
        const seriesObj = [];
        this.addBrandToCompanyAndRemoveIt();
        this.rawSeries.forEach(([seriesTitle, seriesValue]) => {
          seriesObj.push({
            name: this.getChannelColorNameAndIcon(seriesTitle).name,
            y: seriesValue,
            color: this.getChannelColorNameAndIcon(seriesTitle).color,
          });
        });
        return seriesObj;
      }
      return [];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringOverview',
      })
        .then(response => {
          [this.classifiedPercentage, this.rawSeries] = response.talking_about.gender;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    /**
     * Should not show Brand in chart, only company
     */
    addBrandToCompanyAndRemoveIt() {
      const brand = 'Marca';
      const company = 'Organização';
      const brandData = this.rawSeries.find(series => series[0] === brand);
      const organizationData = this.rawSeries.find(series => series[0] === company);
      if (brandData && organizationData) {
        organizationData[1] += brandData[1];
        this.rawSeries = this.rawSeries.filter(series => series[0] !== brand);
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
